/* eslint-disable no-undef */
/* eslint-disable no-console */
/* global window */
import { paramsToQueryString, queryStringToParams } from 'Helpers/url';
import { statusCodes, isSuccess } from '../../helpers/http';
import Auth from '../Auth';
import { setClientIpPort } from 'Actions/api';
import { supportLocalStorage } from 'Helpers/localStorage';

export default fetchImplementation => ({ dispatch, getState }) => next => action => {
    if (action.type === 'API') {
        next(action); // eslint-disable-line callback-return
        const state = getState();
        const { url, method, headers: customHeaders, type, targetUrl } = action.payload;
        let { params } = action.payload;
        const { requested, received, receivedWithError } = action.actions;

        if (url === '') {
            return () => {
            };
        }
        let reduxUrlKey = url;
        let requestUrl = targetUrl || url;
        let queryParam;

        if (typeof url === 'function') {
            requestUrl = url(state);
            reduxUrlKey = url(state);
        }

        if (requestUrl.indexOf('?') !== -1) {
            queryParam = requestUrl.split('?')[1];
            requestUrl = requestUrl.split('?')[0];
            reduxUrlKey = reduxUrlKey.split('?')[0];

            if (queryParam) {
                queryParam = queryStringToParams(queryParam);
            }

            params = params ? { ...params, ...queryParam } : { ...queryParam };
        }

        if (state.api && state.api.queryParam && state.api.queryParam.enableMultiLang && state.api.queryParam.lang) {
            const langQueryParam = { lang: state.api.queryParam.lang };

            if (method !== 'GET' && method !== 'HEAD' && method !== 'DELETE') {
                queryParam = queryParam || {};
                queryParam = queryParam.lang ? queryParam : { ...queryParam, ...langQueryParam };
            }
            else if (typeof FormData === 'undefined' || !(params instanceof FormData)) {
                params = params || {};
                params = params.lang ? params : { ...params, ...langQueryParam };
            }
        }

        const strParams = paramsToQueryString(params);
        let body = params;
        let headers = { ...customHeaders };

        if (state.api && state.api.headers) {
            headers = { ...headers, ...state.api.headers };
        }

        const options = { method, credentials: 'same-origin' };

        if (
            (typeof FormData === 'undefined' || !(params instanceof FormData))
            && headers['Content-Type'] !== 'application/graphql'
        ) {
            body = JSON.stringify(params);
        }

        if (method !== 'GET' && method !== 'HEAD') {
            options.body = body;
            if (typeof FormData === 'undefined' || !(body instanceof FormData)) {
                headers = {
                    ...headers,
                    'Content-Type': 'application/json'
                };
            }
            if (method !== 'DELETE') {
                const strQueryParam = paramsToQueryString(queryParam);

                if (strQueryParam !== '') {
                    requestUrl += `?${strQueryParam}`;
                    reduxUrlKey += `?${strQueryParam}`;
                }
            }
        }

        if (strParams !== '' && (method === 'GET' || method === 'HEAD' || method === 'DELETE')) {
            requestUrl += `?${strParams}`;
            reduxUrlKey += `?${strParams}`;
        }

        options.headers = Object.keys(headers)
            .reduce((h, name) => {
                if (name.toLowerCase() !== 'accept') {
                    h[name] = headers[name];
                }

                return h;
            }, {
                Accept: '*/*'
            });
        if (supportLocalStorage()) {
            options.headers = {
                ...options.headers,
                'X-Panamera-fingerprint': window.localStorage.getItem('device_fingerprint')
            };
        }
        if (requested) {
            dispatch(requested(type, reduxUrlKey));
        }
        let fetchResponse;
        let responseMetadata = {};

        return fetchImplementation(requestUrl, options)
            .then(response => {
                fetchResponse = response;
                responseMetadata = {
                    statusCode: fetchResponse.status,
                    responseHeaders: fetchResponse.headers
                };
                if (method === 'HEAD') {
                    return isSuccess(response.status);
                }
                // TODO : Added Temporarily ( As No content Success Delete Response )
                if (method === 'DELETE') {
                    return isSuccess(response.status);
                }
                if (method === 'GET' && response.status === statusCodes.NOT_FOUND) {
                    return false;
                }
                if (response.status === statusCodes.NO_CONTENT) {
                    return true;
                }
                return response.json();
            })
            .then(json => {
                if (fetchResponse.status === statusCodes.UNAUTHORIZED && Auth.isLoggedIn()) {
                    if (typeof window !== 'undefined' && window.newrelic) {
                        window.newrelic.addPageAction('unauthorized_request_not_blocked', {
                            url: reduxUrlKey
                        });
                    }
                    return dispatch({
                        type: 'UNAUTHORIZED_FETCH',
                        rejectedAction: action
                    });
                }

                /**
                 * For every API request we are intercepting the IP Address and Port of the client
                 * and persisting that in the global state (redux). This ensure that IP:Port information is the latest.
                 * It is later used to pass this information to Tracking service (GTM )
                 * AKAMAI attaches a header called `x-client-info:IP:PORT` for every response
                */
                dispatch(setClientIpPort(fetchResponse.headers));

                if (!isSuccess(fetchResponse.status)) {
                    if (receivedWithError) {
                        dispatch(receivedWithError(type, reduxUrlKey, method, strParams, json, responseMetadata));
                    }
                    return {
                        ok: false,
                        data: json
                    };
                }
                if (received) {
                    dispatch(received(type, reduxUrlKey, method, strParams, json, responseMetadata));
                }
                return {
                    ok: true,
                    data: json
                };
            })
            .catch(e => {
                const json = {
                    ok: false,
                    data: {
                        message: e
                    }
                };

                if (receivedWithError) {
                    dispatch(receivedWithError(type, reduxUrlKey, method, strParams, json, responseMetadata));
                }

                return json;
            });
    }
    return next(action);
};
